// extracted by mini-css-extract-plugin
export default {"propertiesBox":"PropertiesBox_propertiesBox__9fUj2"};